const state = {
	today: '',
	events: []
};

const getters = {
	getToday: (state) => state.today,
	getEvents: (state) => state.events,

};
const actions = {
	storeToday({commit}, payload) {
		commit('setToday', payload.date)
	},
	storeEvents({commit}, payload) {
		commit('setEvents', payload.data)
	},
};
const mutations = {
	setToday: (state, data) => {
		state.today = data;
	},
	setEvents: (state, data) => {
		state.events = data;
	},
};

export default {
	state,
	getters,
	actions,
	mutations
}